Namespace 'Monitoring.Reports.Publications.Content'

class Monitoring.Reports.Publications.Content.CommentView extends Backbone.View

  className: 'content-section content-sentiment'
  template: JST['backbone/templates/monitoring/reports/publications/content/sentiment']

  initialize: (@options = {}) ->

    # just set @options

  render: ->
    @$el.html(@template({ metrics: @options }))
    this

  renderResults: (data) =>
    @$el.addClass('rendered')
    @$el.html(@template({ metrics: data }))
    @trigger('rendered')